import ScheduleInfoTable from './table';
export default ScheduleInfoTable;